var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c("b-table", {
        ref: "applicantListTable",
        attrs: {
          fields: _vm.tableFields,
          items: _vm.$store.state.currentMsApplicantList,
          bordered: "",
          striped: "",
          hover: "",
          footClone: ""
        },
        scopedSlots: _vm._u([
          {
            key: "actions",
            fn: function(row) {
              return [
                _c(
                  "b-button",
                  {
                    attrs: {
                      size: "sm",
                      variant: "outline-info",
                      disabled:
                        _vm.currentMs.seatTaken >= _vm.currentMs.seatTotal
                          ? true
                          : false
                    },
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        _vm.popModal(row.item, row.index, $event.target)
                      }
                    }
                  },
                  [_vm._v("\n        Upload Files\n      ")]
                ),
                _vm._v(" |\n      "),
                _c(
                  "b-button",
                  {
                    attrs: { size: "sm", variant: "danger" },
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        _vm.cancelBooking(row.item, row.index)
                      }
                    }
                  },
                  [_vm._v("\n        Remove\n      ")]
                )
              ]
            }
          }
        ])
      }),
      _c(
        "b-modal",
        {
          ref: "fileUploadModal",
          attrs: { id: "modalInfo", title: _vm.modalInfo.title, size: "lg" },
          on: { hide: _vm.resetModal }
        },
        [
          _c(
            "b-container",
            { attrs: { fluid: "" } },
            [
              _c(
                "b-row",
                [
                  !!_vm.modalInfo.content["fileList"] &&
                  _vm.modalInfo.content["fileList"].length > 0
                    ? _c(
                        "b-col",
                        [
                          _c("strong", { staticStyle: { color: "#184167" } }, [
                            _vm._v(" Uploaded files:")
                          ]),
                          _vm._l(_vm.modalInfo.content["fileList"], function(
                            item,
                            index
                          ) {
                            return _c("h5", [
                              _vm._v(
                                "\n            " +
                                  _vm._s(index + 1) +
                                  ": " +
                                  _vm._s(item) +
                                  "\n          "
                              )
                            ])
                          })
                        ],
                        2
                      )
                    : _c("b-col", [
                        _c("h5", [
                          _vm._v(
                            "\n            No files uploaded yet, applicant is not able to proceed to submit for approval\n          "
                          )
                        ])
                      ])
                ],
                1
              ),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c("UploadFilePanel", {
                        on: { uploadTrainingFiles: _vm.uploadTrainingFiles }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "b-row",
            { attrs: { slot: "modal-footer" }, slot: "modal-footer" },
            [
              _c(
                "b-col",
                { attrs: { sm: "2" } },
                [
                  !!_vm.modalInfo.content["fileList"] &&
                  _vm.modalInfo.content["fileList"].length > 0
                    ? _c(
                        "b-button",
                        {
                          attrs: { variant: "success" },
                          on: { click: _vm.submitForApproval }
                        },
                        [_vm._v("\n          Submit For Approval\n        ")]
                      )
                    : _c(
                        "b-button",
                        { attrs: { disabled: "", variant: "secondary" } },
                        [_vm._v("Submit For Approval")]
                      )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-13834fc6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13834fc6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/mainPage/bookModuleSession/ApplicantList.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-13834fc6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/mainPage/bookModuleSession/ApplicantList.vue
// module chunks = 8